var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobCrossShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #12b0e0;\n      }\n\n      .cls-2 {\n        fill: #301d29;\n      }\n\n      .cls-3 {\n        fill: #261722;\n      }\n\n      .cls-4 {\n        fill: #3f2738;\n      }\n\n      .cls-5 {\n        fill: #5b4956;\n      }\n\n      .cls-6 {\n        fill: #119ebf;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "524.04 362.73 498.04 366.64 443.94 366.64 443.94 320.59 524.04 332.62 524.04 362.73"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "469 343.39 505 294.39 423 294.39 169.44 338.02 123.59 368.34 317.72 378.33 477.31 383.35 469 343.39"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "477.31 383.35 144.94 383.41 123.59 368.34 474 367.39 477.31 383.35"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "458.22 440.26 276.13 420.79 263.33 408.21 458.73 426.21 458.22 440.26"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "273.31 399.23 161.28 392.8 161.28 388.21 273.31 381.78 273.31 399.23"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "458.36 426.21 262.96 408.21 233 365.99 439.38 368.2 458.36 426.21"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "447 390.39 458.33 426.03 263 408.39 447 390.39"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "505 294.39 537 266.39 263 297.39 169.15 337.74 423 294.39 505 294.39"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "314 366.39 169.15 337.74 123.35 368.49 314 366.39"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "423 294.39 169 338.39 263 297.39 423 294.39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobCrossShip);
export default __webpack_public_path__ + "static/media/mob-cross-ship.0fcda32968cc34d1a4a92ec8f1d3bfdb.svg";
export { ForwardRef as ReactComponent };